import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import NavigationMenu from "@/components/layout/NavigationMenu";
import { toast } from "@/components/ui/use-toast";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("subscription");

  useEffect(() => {
    toast({
      title: t("paymentSuccess.title"),
      description: t("paymentSuccess.congratulations"),
    });
  }, [t]);

  return (
    <div className="min-h-screen bg-background">
      <NavigationMenu />
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <Card className="text-center">
          <CardHeader>
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl text-green-600">
              {t("paymentSuccess.title")}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              {t("paymentSuccess.congratulations")}
            </p>
            
            {/* Important: Email notification for password creation with strong animation */}
            <div className="bg-amber-100 border-2 border-amber-500 p-4 rounded-lg animate-[pulse_1s_ease-in-out_infinite] shadow-lg shadow-amber-200">
              <h3 className="font-bold text-amber-800 mb-2 flex items-center justify-center gap-2 text-lg">
                📧 {t("paymentSuccess.nextStep.title")}
              </h3>
              <p 
                className="text-sm text-amber-900 font-medium"
                dangerouslySetInnerHTML={{ __html: t("paymentSuccess.nextStep.description") }}
              />
            </div>
            
            <div className="bg-muted p-4 rounded-lg">
              <h3 className="font-semibold mb-2">{t("paymentSuccess.whatAwaits")}</h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>✅ {t("paymentSuccess.features.unlimitedTests")}</li>
                <li>✅ {t("paymentSuccess.features.aiAnalysis")}</li>
                <li>✅ {t("paymentSuccess.features.advancedTracking")}</li>
                <li>✅ {t("paymentSuccess.features.detailedStats")}</li>
                <li>✅ {t("paymentSuccess.features.prioritySupport")}</li>
              </ul>
            </div>

            <div className="flex flex-col gap-4 justify-center pt-4">
              <Button onClick={() => navigate('/auth')} className="w-full">
                {t("paymentSuccess.buttons.login")}
              </Button>
              <Button onClick={() => window.open('https://payment.golf-progress-calculator.com/p/login/4gMbJ10Ke283e2C3In4gg00', '_blank')} variant="outline" className="w-full">
                {t("paymentSuccess.buttons.manageSubscription")}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
